const pageStates =  {
    BASIC_INFO_PAGE: "BASIC_INFO_PAGE",
    ADVANCED_INFO_PAGE: "ADVANCED_INFO_PAGE",
    MULTI_SIZES_PAGE: "MULTI_SIZES_PAGE",
    VISUALISATION_PAGE: "VISUALISATION_PAGE",
}

export default pageStates;